import React from 'react';

import SvgContainer from '../SvgContainer';

const Goal = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100957)">
                <path d="M8 5.09091C6.39273 5.09091 5.09091 6.39273 5.09091 8C5.09091 9.60727 6.39273 10.9091 8 10.9091C9.60727 10.9091 10.9091 9.60727 10.9091 8C10.9091 6.39273 9.60727 5.09091 8 5.09091ZM14.5018 7.27273C14.1673 4.24 11.76 1.83273 8.72727 1.49818V0.727273C8.72727 0.325611 8.40166 0 8 0C7.59834 0 7.27273 0.325611 7.27273 0.727273V1.49818C4.24 1.83273 1.83273 4.24 1.49818 7.27273H0.727273C0.325611 7.27273 0 7.59834 0 8C0 8.40166 0.325611 8.72727 0.727273 8.72727H1.49818C1.83273 11.76 4.24 14.1673 7.27273 14.5018V15.2727C7.27273 15.6744 7.59834 16 8 16C8.40166 16 8.72727 15.6744 8.72727 15.2727V14.5018C11.76 14.1673 14.1673 11.76 14.5018 8.72727H15.2727C15.6744 8.72727 16 8.40166 16 8C16 7.59834 15.6744 7.27273 15.2727 7.27273H14.5018ZM8 13.0909C5.18545 13.0909 2.90909 10.8145 2.90909 8C2.90909 5.18545 5.18545 2.90909 8 2.90909C10.8145 2.90909 13.0909 5.18545 13.0909 8C13.0909 10.8145 10.8145 13.0909 8 13.0909Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100957">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Goal;
